/**
 * Pages the api renders whole into news-page/index.html: the news (/news/...) and the
 * characters' share pages (/c/<server>/<name>/). Here the header comes alive, dates follow the
 * reader's language and a character is drawn in 3D, as in the game.
 */
import "../i18n/boot";
import { resumeSession } from "../http";
import { lang } from "../i18n";
import { mountNav } from "./nav";

const dateFmt = new Intl.DateTimeFormat(lang() === "tr" ? "tr-TR" : "en-GB", {
  day: "numeric",
  month: "long",
  year: "numeric",
});
for (const time of document.querySelectorAll<HTMLTimeElement>("time[datetime]")) {
  const at = new Date(time.dateTime);
  if (!Number.isNaN(at.getTime())) time.textContent = dateFmt.format(at);
}

// The header shows the last known session at once, then the real one.
const siteNav = mountNav();
void resumeSession()
  .then((token) => siteNav.setSignedIn(token !== null))
  .catch(() => siteNav.setSignedIn(false));

// A character's share page: the character itself, drawn by the game's own preview (loaded only
// here, it is the heavy part). Drag to turn it.
const stage = document.querySelector<HTMLElement>(".char-stage");
const canvas = stage?.querySelector<HTMLCanvasElement>("canvas");
if (stage && canvas) {
  void Promise.all([import("../ui/charPreview"), import("../gearLook")]).then(
    ([{ CharPreview }, { parseGear }]) => {
      const look = JSON.parse(stage.dataset.look ?? "{}");
      const preview = new CharPreview(canvas, { full: true });
      preview.setLook({
        race: look.race,
        gender: look.gender,
        cls: look.cls,
        seed: look.seed,
        gear: parseGear(look.gear ?? ""),
        skin: look.skin || undefined,
      });
      preview.turnTo(0.4);
      preview.update(true);
      stage.classList.add("ready");
    },
  );
}
